var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import Sticky from "react-sticky-el";
import connect from "@irati/store/connect";
import { H4 } from "@irati/ui/src/Headings";
import { Grid as GridBase, Row, Col } from "react-bootstrap";
import Banner from "@irati/ui/src/Banner";
import Modal from "@irati/ui/src/Modal";
import { FormattedMessage } from "@irati/utils/lang";
import RewardDetail, { RewardSummary } from "@irati-web/reward/src/components/Detail";
import Card from "@irati/ui/src/Layout/Card";
import Markdown from "@irati/ui/src/Markdown";
var Grid = styled(GridBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: -200px;\n"], ["\n  margin-top: -200px;\n"])));
var RewardDetailContainer = /** @class */ (function (_super) {
    __extends(RewardDetailContainer, _super);
    function RewardDetailContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isTermsAndConditionsShown: false
        };
        _this.showTermsAndConditions = function () {
            _this.setState({
                isTermsAndConditionsShown: true
            });
        };
        _this.hideTermsAndConditions = function () {
            _this.setState({
                isTermsAndConditionsShown: false
            });
        };
        return _this;
    }
    RewardDetailContainer.prototype.renderSidebar = function () {
        var reward = this.props.reward;
        return (React.createElement(Card, null,
            React.createElement(RewardSummary, { reward: reward, onClickTermsAndConditions: this.showTermsAndConditions })));
    };
    RewardDetailContainer.prototype.render = function () {
        var _a = this.props, isMobile = _a.isMobile, reward = _a.reward;
        var isTermsAndConditionsShown = this.state.isTermsAndConditionsShown;
        return (React.createElement(React.Fragment, null,
            React.createElement(Banner, { backgroundColor: "transparent", bannerImg: reward.bannerImage }),
            React.createElement(Grid, null,
                React.createElement(Row, null,
                    React.createElement(Col, { md: 8, sm: 12 },
                        React.createElement(Card, { large: true },
                            React.createElement(RewardDetail, { reward: reward }))),
                    React.createElement(Col, { md: 4 }, isMobile ?
                        this.renderSidebar()
                        :
                            React.createElement(Sticky, { stickyStyle: { marginTop: "20px" } }, this.renderSidebar())))),
            reward.termsAndConditions && (React.createElement(Modal, { show: isTermsAndConditionsShown, onHide: this.hideTermsAndConditions },
                React.createElement(H4, null,
                    React.createElement(FormattedMessage, { id: "reward.detail.termsAndConditions.title" })),
                React.createElement(Markdown, { source: reward.termsAndConditions })))));
    };
    return RewardDetailContainer;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isMobile: mq.lessThan.md
    });
};
export default connect(mapStateToProps)(RewardDetailContainer);
var templateObject_1;
